export default __webpack_public_path__ + "static/media/GHNL.78831d0f.png";